import React from "react";
import SingleCard from "./single-card";
import styles from "./index.module.scss";

const DesktopGrid = ({ loanTerms }) => {
  return (
    <div className={`${styles.cardsGrid} container`}>
      {loanTerms.map((term, index) => {
        return <SingleCard term={term} key={index} />;
      })}
    </div>
  );
};

export default DesktopGrid;
